import { EXPRESS_API_PATHS } from '../constants/express'
import type { ExpressCheckResult } from './types'
import { apiRequest } from './client'

export function checkExpressAvailability(input: {
  variantIds: string[]
  latitude: number
  longitude: number
}): Promise<ExpressCheckResult> {
  return apiRequest<ExpressCheckResult>(EXPRESS_API_PATHS.check, {
    method: 'POST',
    body: {
      variantIds: input.variantIds,
      latitude: input.latitude,
      longitude: input.longitude,
    },
  })
}
